import React from 'react';
import CONST from '../../config/const'

class ZendeskJs extends React.Component {
  componentDidMount() {
    var s = document.querySelector("#jsonp");
    s && s.parentNode.removeChild(s);
    var script = document.createElement("script");
    script.id = "ze-snippet";
    script.src =
      "https://static.zdassets.com/ekr/snippet.js?key=" + CONST.zendesk_key;
    document.body.appendChild(script);
  }

  render() {
    return <div></div>;
  }
}

export default ZendeskJs;
